import { render } from "./UpdateProductPanel.vue?vue&type=template&id=9a6e658a&scoped=true"
import script from "./UpdateProductPanel.vue?vue&type=script&lang=js"
export * from "./UpdateProductPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6e658a"]])

export default __exports__